export const MODAL_DIALOG__SITE_PREVIEW = 'MODAL_DIALOG__SITE_PREVIEW';
